/**
 * @generated SignedSource<<79ad07372bbdcfc5bfb3d197ac5f3f28>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchJiraProject_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultJiraProject";
  readonly description: string;
  readonly iconUrl: string | null | undefined;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly project: {
    readonly avatar?: {
      readonly small: string | null | undefined;
    } | null | undefined;
    readonly category?: {
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly lead?: {
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
    readonly projectStyle?: JiraProjectStyle | null | undefined;
    readonly projectType?: JiraProjectType | null | undefined;
    readonly webUrl: AGG$URL | null | undefined;
  } | null | undefined;
  readonly projectKey: string;
  readonly socialSignal: {
    readonly signal: string | null | undefined;
    readonly timestamp: string | null | undefined;
    readonly user: {
      readonly accountId: string;
      readonly email?: string | null | undefined;
      readonly extendedProfile?: {
        readonly jobTitle: string | null | undefined;
      } | null | undefined;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  } | null | undefined;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchJiraProject_AtlassianSearchPage";
};
export type searchJiraProject_AtlassianSearchPage$key = {
  readonly " $data"?: searchJiraProject_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchJiraProject_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
},
v1 = {
  "kind": "ScalarField",
  "name": "picture"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeJiraLiteModeFields"
    },
    {
      "kind": "RootArgument",
      "name": "tenantId"
    }
  ],
  "kind": "Fragment",
  "name": "searchJiraProject_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "projectKey"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "kind": "ScalarField",
      "name": "iconUrl"
    },
    {
      "concreteType": "JiraProject",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "webUrl"
        },
        {
          "condition": "includeJiraLiteModeFields",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "lead",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ]
            },
            {
              "concreteType": "JiraAvatar",
              "kind": "LinkedField",
              "name": "avatar",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "small"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "projectStyle"
            },
            {
              "kind": "ScalarField",
              "name": "projectType"
            },
            {
              "concreteType": "JiraProjectCategory",
              "kind": "LinkedField",
              "name": "category",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ]
            }
          ]
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "tenantId",
          "variableName": "tenantId"
        }
      ],
      "concreteType": "SocialSignalSearch",
      "kind": "LinkedField",
      "name": "socialSignal",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "signal"
        },
        {
          "kind": "ScalarField",
          "name": "timestamp"
        },
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountId"
            },
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "email"
                },
                {
                  "concreteType": "AtlassianAccountUserExtendedProfile",
                  "kind": "LinkedField",
                  "name": "extendedProfile",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "jobTitle"
                    }
                  ]
                }
              ],
              "type": "AtlassianAccountUser"
            }
          ]
        }
      ]
    }
  ],
  "type": "SearchResultJiraProject"
};
})();

(node as any).hash = "16380ef5d22d59f2b0f43c47e296b88b";

export default node;
